// Slim slice of enums used by the staff app. Lifted from
// `scio3/packages/shared-types/src/enums.ts`. Keep additions minimal — staff
// owns admin_users + MDM peer views, not the full content model.

export const ROLE_TYPES = {
  OWNER: '0',
  ADMIN: '1',
  INVITED: '2',
  USER: '3',
  CONTENT_PROPOSAL: '4',
  CONTENT_APPROVAL: '5',
  READ_ONLY: '6',
  TEAM_OWNER: '7',
  SUPER_ADMIN: '8',
} as const;

export type RoleType = (typeof ROLE_TYPES)[keyof typeof ROLE_TYPES];

export const SORT_DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type SortDirection = (typeof SORT_DIRECTION)[keyof typeof SORT_DIRECTION];
